      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>

      <div *ngIf="!carInformacionInicial">
        <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
          <p-accordionTab header="{{ 'MODALIDADES.LBL_INFORGENERAL' | translate }}" [selected]="tabSeleccionado === 'INFO'">
            <div class="grid">
              <div class="col-12">
                <p-panel header="{{ 'MODALIDADES.LBL_INFOMODALIDAD' | translate}}" *ngIf="modalidad">
                  <div class="grid">
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_CODIGO' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8 "><strong>{{modalidad.codigo}}</strong></label>
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_NOMBRE' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{modalidad.nombre}}</strong></label>
                  </div>
                  <div class="grid">
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_CODIGO_SHIVAM' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{modalidad.codigoShivam}}</strong></label>
                  </div>
                  <div class="grid">
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_DESCRIPCION' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{ modalidad.descripcion }}</strong></label>
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_TASA' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{modalidad.tasa}}</strong></label>
                  </div>
                  <div class="grid">
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_HABILITADO' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{(modalidad.indicadorHabilitado ? 'LBL_SI' : 'LBL_NO') | translate}}</strong></label>
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_FECHA' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{modalidad.fechaCreacion}}</strong></label>
                  </div>
                  <div class="grid" *ngIf="modalidad.indicadorConvenioFga">
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_PAGAREMATERIAL' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{modalidad.fgaMaterial}}</strong></label>
                  </div>
                  <div class="grid" *ngIf="modalidad.indicadorConvenioFga">
                    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'MODALIDADES.LBL_PAGAREINMATERIAL' | translate }}:</label>
                    <label class="lg:col-3 col-6 md:col-8"><strong>{{modalidad.fgaInmaterial}}</strong></label>
                  </div>
                </p-panel>
              </div>
            </div>
            <div class="grid">
              <div class="col-12">
                <p-table [columns]="colAutorizacion"
                         [value]="autorizaciones"
                         selectionMode="single" dataKey="idCanalProducto"
                         [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row">
                      <td>{{row.label}}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns.length">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                        pButton (click)="regresar()"></button>
              </div>
            </div>

          </p-accordionTab>
          <p-accordionTab header="{{ 'MODALIDADES.LBL_FACTORCREZCAMOS' | translate }}" [selected]="tabSeleccionado === 'FACT'" [disabled]="!modalidad">
            <app-modalidades-factor-crezcamos [modalidad]="modalidad" *ngIf="modalidad && modalidad.idModalidad" [esDetalle]="true">
            </app-modalidades-factor-crezcamos>

          </p-accordionTab>
          <p-accordionTab header="{{ 'MODALIDADES.LBL_CALIFICACION' | translate }}" [selected]="tabSeleccionado === 'CALI'">

            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12">

                <div class="grid form-group">
                  <div class="col-12 md:col-3 lg:col-4 md:col-offset-2 lg:col-offset-2">
                    <div class="div-form">
                      <label>{{'MODALIDADES.LBL_REINCIDENCIA' | translate}}: </label>
                      <label class="falso-combo-texto"><b>{{ modalidad.reincidencia }}</b></label>
                    </div>
                  </div>

                  <div class="col-12 md:col-3 lg:col-4">
                    <div class="div-form">
                      <label>{{'MODALIDADES.LBL_DIASMORA' | translate}}: </label>
                      <label class="falso-combo-texto"><b>{{ modalidad.diaMora }}</b></label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12">
                <p-table [columns]="columnas"
                         [value]="lisModalidadesCalificaciones" selectionMode="single" dataKey="idAutorizacion"
                         [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                          class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row">
                      <td>{{row.codigoCategoria}}</td>
                      <td>{{row.diaMinimoMora}}</td>
                      <td>{{row.diaMaximoMora}}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns.length">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                        pButton (click)="regresar()"></button>
              </div>
            </div>

          </p-accordionTab>
        </p-accordion>

      </div>

